document.addEventListener('DOMContentLoaded', () => {
  const teamTextNodes = document.querySelectorAll('.team__list-text');
  const isMobileWidth = () => window.innerWidth <= 500;

  const updateTeamItemsState = () => {
    const mobileWidth = isMobileWidth();
    teamTextNodes.forEach(textNode => {
      textNode.setAttribute('aria-expanded', mobileWidth ? 'false' : 'true');
      textNode.style.pointerEvents = mobileWidth ? 'auto' : 'none';
    });
  };

  updateTeamItemsState();
  window.addEventListener('resize', updateTeamItemsState);

  teamTextNodes.forEach(textNode => textNode.querySelector('.team__summary')?.addEventListener('click', () => {
    if (isMobileWidth()) {
      textNode.setAttribute('aria-expanded', textNode.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    }
  }));
});